import { DataFormats } from '@skylab-shared/constants';
import { format, parse } from 'fecha';
import { isIsoDateTime } from './date-utils';

const isDate = (dt: Date) => (dt.getHours() + dt.getMinutes() + dt.getSeconds() + dt.getMilliseconds()) === 0;
const parseRequest = (dataPart: any): string | Array<any> | Record<string, any> | null => {
    if (typeof dataPart === 'string' && isIsoDateTime(dataPart)) {
        const dateWithLocalTimeZone = parse(dataPart, DataFormats.date.webApiDateTimeWithTimeZone);
        if (dateWithLocalTimeZone) {
            if (isDate(dateWithLocalTimeZone)) {
                return format(dateWithLocalTimeZone, DataFormats.date.webApi);
            }
            const utcDate = new Date(dateWithLocalTimeZone.getTime() + dateWithLocalTimeZone.getTimezoneOffset() * 60 * 1000);
            return format(utcDate, DataFormats.date.webApiDateTime);
        }
    } else if (dataPart instanceof Array) {
        return dataPart.map(value => parseRequest(value));
    } else if (typeof dataPart === 'object' && (dataPart != null)) {
        const obj = dataPart as Record<string, any>;
        return Object.keys(obj)
            .map(key => ([key, obj[key]]))
            .reduce<Record<string, any>>((acc, [key, value]) => (acc[key] = parseRequest(value), acc), {});
    }
    return dataPart;
};

export function handleDateInRequest(data: any): string {
    if (data == null || data instanceof FormData) {
        return data;
    }

    const parsedRequest = parseRequest(JSON.parse(data));

    return JSON.stringify(parsedRequest);
}
